export enum LicensePoolType {
  RESERVED_POOL,
}
